import { Query } from '@apollo/client/react/components';
import {
  TEMPLATE_SUB_TYPES,
  TEMPLATE_TYPES
} from '@nile/banyan/src/Constants/notifications';
import {
  GET_ROLES,
  GET_REQUESTER_ROLES
} from '@nile/banyan/src/Graphql/Mutations/role';
import { GET_NOTIFICATION_TEMPLATE_META_INFO } from '@nile/banyan/src/Graphql/Mutations/templates';
import { getTranslatedText } from '@nile/components';
import { HeaderTag } from '@nile/components/src';
import { AccountClient, GET_ALL_TECHS_NEW } from '@nile/graphql';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import CreatableSelect from 'react-select/creatable';
import styled from 'styled-components';

// constants
function EmailSenderForm(props) {
  // const senderTypeOptions = [
  //   { label: 'MSP', value: 'MSP' },
  //   { label: 'Technician', value: 'TECHNICIAN' },
  //   { label: 'Custom', value: 'CUSTOM' }
  // ];

  // const emailSignatureTypeOptions = [
  //   { label: 'MSP', value: 'MSP' },
  //   { label: 'Technician', value: 'TECHNICIAN' }
  // ];

  // Initializations
  const { intl, template } = props;
  // const [senderNameType, setSenderNameType] = useState({});
  // const [senderNameValue, setSenderNameValue] = useState(null);
  const [ccUsers, setCCUsers] = useState([]);
  const [bccUsers, setBCCUsers] = useState([]);
  const [toUsers, setToUsers] = useState([]);
  // const [emailSignatureType, setEmailSignatureType] = useState(null);
  const [placeholders, setPlaceholders] = useState(props?.placeholders || []);
  const [requesterRoles, setRequesterRoles] = useState([]);

  const getNotificationMetaInfo = async (type) => {
    await AccountClient.query({
      query: GET_NOTIFICATION_TEMPLATE_META_INFO,
      variables: {
        templateType: template?.templateType,
        templateSubtype: type,
        constant: template?.constant
      },
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res.data?.getNotificationTemplateMetaInfo?.recipientsPlaceHolders) {
        setPlaceholders(
          res.data.getNotificationTemplateMetaInfo.recipientsPlaceHolders
        );
      }
    });
  };

  const getRequesterRoles = async () => {
    await AccountClient.query({
      query: GET_REQUESTER_ROLES,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res?.data?.getUserRoleTypeRoles) {
        setRequesterRoles(res.data.getUserRoleTypeRoles);
      }
    });
  };

  // prefilling data
  function getSingleSelectProcessedData(value) {
    return {
      label: value,
      value
    };
  }
  function getMultiSelectProcessedData(data) {
    const processedData = [];
    if (data) {
      data.forEach((obj) => {
        if (obj.user) {
          obj.user['label'] = obj.user.name;
          obj.user['value'] = obj.user.name;
          processedData.push(obj.user);
        }
        if (obj.type === 'EMAIL') {
          processedData.push({
            label: obj.email,
            value: obj.email,
            __isNew__: true
          });
        }
        if (obj.type === 'USER_TYPE_ROLE') {
          processedData.push({
            label: obj.userTypeRole.name,
            value: `${obj.userTypeRole.roleId}`,
            roleId: `${obj.userTypeRole.roleId}`
          });
        }
        if (obj.type === 'PLACEHOLDER') {
          processedData.push({
            label: getTranslatedText(intl, obj.placeHolder),
            value: obj.placeHolder
          });
        }
      });
    }
    return processedData;
  }

  useEffect(() => {
    setPlaceholders(props.placeholders);
  }, [props.placeholders]);

  useEffect(() => {
    getNotificationMetaInfo(template.templateSubtype);
    if (
      template.templateSubtype === TEMPLATE_SUB_TYPES.requester &&
      (template.templateType === TEMPLATE_TYPES.systemTicketing ||
        template.templateType === TEMPLATE_TYPES.customTicketing)
    ) {
      getRequesterRoles();
    }
    const clonedTemplate = _.cloneDeep(template);
    setToUsers(getMultiSelectProcessedData(clonedTemplate.to));
    setCCUsers(getMultiSelectProcessedData(clonedTemplate.cc));
    setBCCUsers(getMultiSelectProcessedData(clonedTemplate.bcc));
  }, [template.templateSubtype]);

  useEffect(() => {
    const clonedTemplate = _.cloneDeep(template);
    const {
      senderNameType: senderType,
      senderNameValue: senderValue,
      cc,
      bcc,
      to,
      emailSignatureType: emailType
    } = clonedTemplate;
    // setSenderNameType(getSingleSelectProcessedData(senderType));
    // setSenderNameValue(senderValue);
    setToUsers(getMultiSelectProcessedData(to));
    setCCUsers(getMultiSelectProcessedData(cc));
    setBCCUsers(getMultiSelectProcessedData(bcc));
    // setEmailSignatureType(getSingleSelectProcessedData(emailType));
  }, [template]);

  // handling on change
  // const handleSenderTypeChange = (val) => {
  //   setSenderNameType(val);
  //   template.senderNameType = val.value;
  //   if (val.value !== 'CUSTOM') {
  //     setSenderNameValue(null);
  //     template.senderNameValue = null;
  //   }
  // };

  // const handleSenderTypeValueChange = (val) => {
  //   setSenderNameValue(val);
  //   template.senderNameValue = val;
  // };

  // TODO: Do not modify props as such - Call proper setter
  const updateccUsers = (val) => {
    setCCUsers(val);
    if (_.isEmpty(val)) {
      template.cc = [];
      return;
    }
    const clonedVal = _.cloneDeep(val);
    template.cc = [];
    clonedVal.forEach((obj) => {
      // delete obj.label;
      // delete obj.value;
      if (obj?.userId) {
        delete obj.label;
        delete obj.value;
        template.cc.push({ type: 'USER', user: obj });
      } else if (obj?.roleId) {
        template.to.push({
          type: 'USER_TYPE_ROLE',
          userTypeRole: {
            roleId: obj.roleId,
            name: obj.name || obj.label
          }
        });
      } else if (obj.__isNew__) {
        template.cc.push({ type: 'EMAIL', email: obj.value });
      } else {
        template.cc.push({ type: 'PLACEHOLDER', placeHolder: obj.value });
      }
    });
  };

  const updatetoUsers = (val) => {
    setToUsers(val);
    if (_.isEmpty(val)) {
      template.to = [];
      return;
    }
    const clonedVal = _.cloneDeep(val);
    template.to = [];
    clonedVal.forEach((obj) => {
      // delete obj.label;
      // delete obj.value;
      if (obj?.userId) {
        delete obj.label;
        delete obj.value;
        template.to.push({ type: 'USER', user: obj });
      } else if (obj?.roleId) {
        template.to.push({
          type: 'USER_TYPE_ROLE',
          userTypeRole: {
            roleId: obj.roleId,
            name: obj.name || obj.label
          }
        });
      } else if (obj.__isNew__) {
        template.to.push({ type: 'EMAIL', email: obj.value });
      } else {
        template.to.push({ type: 'PLACEHOLDER', placeHolder: obj.value });
      }
    });
  };

  const updatebccUsers = (val) => {
    setBCCUsers(val);
    if (_.isEmpty(val)) {
      template.bcc = [];
      return;
    }
    const clonedVal = _.cloneDeep(val);
    template.bcc = [];
    clonedVal.forEach((obj) => {
      // delete obj.label;
      // delete obj.value;
      if (obj?.userId) {
        delete obj.label;
        delete obj.value;
        template.bcc.push({ type: 'USER', user: obj });
      } else if (obj?.roleId) {
        template.to.push({
          type: 'USER_TYPE_ROLE',
          userTypeRole: {
            roleId: obj.roleId,
            name: obj.name || obj.label
          }
        });
      } else if (obj.__isNew__) {
        template.bcc.push({ type: 'EMAIL', email: obj.value });
      } else {
        template.bcc.push({ type: 'PLACEHOLDER', placeHolder: obj.value });
      }
    });
  };

  // const handleEmailSignatureTypeChange = (val) => {
  //   setEmailSignatureType(val);
  //   template.emailSignatureType = val.value;
  // };

  return (
    <div className="w40">
      <HeaderTag
        title={getTranslatedText(intl, 'admin.emailNotification.prop')}
        isBgStrip
        isNewLayout
      />
      <div className="mt25">
        {/* <SelectContainer className="fx select-wrapper">
          <div className="container">
            <Label>
              {getTranslatedText(
                intl,
                'admin.emailNotification.prop.choose.label'
              )}
            </Label>
            <Select
              className="email-props-sender-type"
              options={senderTypeOptions}
              onChange={handleSenderTypeChange}
              value={senderNameType}
              placeholder={getTranslatedText(
                intl,
                'admin.emailNotification.prop.choose'
              )}
              name="valueselector"
              classNamePrefix="value_selector"
              components={{ IndicatorSeparator, DropdownIndicator }}
              formatGroupLabel={formatGroupLabel}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }}
            />
          </div>
        </SelectContainer>
        <br />
        {senderNameType.value === 'CUSTOM' ? (
          <div className="custom-sender">
            <TextField
              label={getTranslatedText(
                intl,
                'admin.emailNotification.custom.value'
              )}
              value={senderNameValue}
              onChange={handleSenderTypeValueChange}
            />
            <br />
          </div>
        ) : null} */}
        {template?.canConfigureTo && (
          <Query
            query={GET_ALL_TECHS_NEW}
            client={AccountClient}
            variables={{
              input: {
                listInfo: {
                  sort: {
                    attribute: 'name',
                    order: 'ASC'
                  }
                }
              }
            }}
          >
            {({ loading, error, data: techs }) => {
              if (loading) {
                return <div>loading</div>;
              }
              if (error) {
                return <div>error</div>;
              }

              let techsData = JSON.parse(
                JSON.stringify(techs?.getTechnicianList?.userList)
              );

              techsData = techsData.map((item) => {
                return {
                  ...item,
                  label: item.name,
                  value: item.name
                };
              });

              let placeholderData = placeholders?.map((placeholder) => ({
                ...placeholder,
                label: getTranslatedText(intl, placeholder.value),
                name: placeholder.value
              }));

              let rolesData = requesterRoles?.map((role) => ({
                ...role,
                label: getTranslatedText(intl, role.name),
                value: role.roleId
              }));

              const allData =
                template?.templateSubtype === TEMPLATE_SUB_TYPES.technician ||
                template?.templateType === TEMPLATE_TYPES.sideConversation
                  ? [
                      { label: 'Placeholders', options: [...placeholderData] },
                      { label: 'Technicians', options: [...techsData] }
                    ]
                  : template?.templateType === TEMPLATE_TYPES.customTicketing ||
                    template?.templateType === TEMPLATE_TYPES.systemTicketing
                  ? [
                      { label: 'Placeholders', options: [...placeholderData] },
                      { label: 'Roles', options: [...rolesData] }
                    ]
                  : [{ label: 'Placeholders', options: [...placeholderData] }];

              const getSelectedObj = (name) => {
                return allData.find((tech) => tech.name === name);
              };

              return (
                <div className="ml-12 mb-20 taskStatus">
                  <div className="Polaris-Labelled__LabelWrapper">
                    <div className="Polaris-Label">
                      <label
                        id="employeePhoneLabel"
                        for="employeePhone"
                        className="Polaris-Label__Text"
                      >
                        {getTranslatedText(
                          intl,
                          'admin.emailNotification.prop.container.to.label'
                        )}
                      </label>
                    </div>
                  </div>
                  <CreatableSelect
                    value={toUsers}
                    // styles={
                    //   errors?.statusId
                    //     ? {
                    //         ...MenuStyle,
                    //         ...statusStylesObject,
                    //         ...reactSelectErrorStyles
                    //       }
                    //     : {
                    //         ...MenuStyle,
                    //         ...statusStylesObject,
                    //         ...{
                    //           container: (provided, state) => ({
                    //             ...provided,
                    //             width: '150px'
                    //           })
                    //         }
                    //       }
                    // }
                    name="valueselector"
                    classNamePrefix="value_selector"
                    components={{ IndicatorSeparator, DropdownIndicator }}
                    formatGroupLabel={formatGroupLabel}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 })
                    }}
                    isMulti
                    onChange={updatetoUsers}
                    options={allData}
                    // isSearchable={false}
                  />
                </div>
              );
            }}
          </Query>
        )}
        {template?.canConfigureCcAndBcc && (
          <>
            <Query
              query={GET_ALL_TECHS_NEW}
              client={AccountClient}
              variables={{
                input: {
                  listInfo: {
                    sort: {
                      attribute: 'name',
                      order: 'ASC'
                    }
                  }
                }
              }}
            >
              {({ loading, error, data: techs }) => {
                if (loading) {
                  return <div>loading</div>;
                }
                if (error) {
                  return <div>error</div>;
                }

                let techsData = JSON.parse(
                  JSON.stringify(techs?.getTechnicianList?.userList)
                );

                techsData = techsData.map((item) => {
                  return {
                    ...item,
                    label: item.name,
                    value: item.name
                  };
                });

                let placeholderData = placeholders?.map((placeholder) => ({
                  ...placeholder,
                  label: getTranslatedText(intl, placeholder.value),
                  name: placeholder.value
                }));

                const allData =
                  template?.templateSubtype === TEMPLATE_SUB_TYPES.technician
                    ? [
                        {
                          label: 'Placeholders',
                          options: [...placeholderData]
                        },
                        { label: 'Technicians', options: [...techsData] }
                      ]
                    : [
                        { label: 'Placeholders', options: [...placeholderData] }
                      ];

                const getSelectedObj = (name) => {
                  return allData.find((tech) => tech.name === name);
                };

                return (
                  <div className="ml-12 mb-20 taskStatus">
                    <div className="Polaris-Labelled__LabelWrapper">
                      <div className="Polaris-Label">
                        <label
                          id="employeePhoneLabel"
                          for="employeePhone"
                          className="Polaris-Label__Text"
                        >
                          {getTranslatedText(
                            intl,
                            'admin.emailNotification.prop.container.cc.label'
                          )}
                        </label>
                      </div>
                    </div>
                    <CreatableSelect
                      value={ccUsers}
                      // styles={
                      //   errors?.statusId
                      //     ? {
                      //         ...MenuStyle,
                      //         ...statusStylesObject,
                      //         ...reactSelectErrorStyles
                      //       }
                      //     : {
                      //         ...MenuStyle,
                      //         ...statusStylesObject,
                      //         ...{
                      //           container: (provided, state) => ({
                      //             ...provided,
                      //             width: '150px'
                      //           })
                      //         }
                      //       }
                      // }
                      name="valueselector"
                      classNamePrefix="value_selector"
                      components={{ IndicatorSeparator, DropdownIndicator }}
                      formatGroupLabel={formatGroupLabel}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      isMulti
                      onChange={updateccUsers}
                      options={allData}
                      // isSearchable={false}
                    />
                  </div>
                );
              }}
            </Query>
            {/* <SelectUsers
              updateField={updateccUsers}
              query={GET_ALL_TECHS}
              label={<Label>{'CC Users'}</Label>}
              params={{
                client: AccountClient
              }}
              methodName="getAllTechnicians"
              value={ccUsers}
              placeholder={getTranslatedText(
                intl,
                'admin.emailNotification.cc'
              )}
              isMulti
            /> */}
            <br />
            <Query
              query={GET_ALL_TECHS_NEW}
              client={AccountClient}
              variables={{
                input: {
                  listInfo: {
                    sort: {
                      attribute: 'name',
                      order: 'ASC'
                    }
                  }
                }
              }}
            >
              {({ loading, error, data: techs }) => {
                if (loading) {
                  return <div>loading</div>;
                }
                if (error) {
                  return <div>error</div>;
                }

                let techsData = JSON.parse(
                  JSON.stringify(techs?.getTechnicianList?.userList)
                );

                techsData = techsData.map((item) => {
                  return {
                    ...item,
                    label: item.name,
                    value: item.name
                  };
                });

                let placeholderData = placeholders?.map((placeholder) => ({
                  ...placeholder,
                  label: getTranslatedText(intl, placeholder.value),
                  name: placeholder.value
                }));

                const allData =
                  template?.templateSubtype === TEMPLATE_SUB_TYPES.technician
                    ? [
                        {
                          label: 'Placeholders',
                          options: [...placeholderData]
                        },
                        { label: 'Technicians', options: [...techsData] }
                      ]
                    : [
                        { label: 'Placeholders', options: [...placeholderData] }
                      ];

                const getSelectedObj = (name) => {
                  return allData.find((tech) => tech.name === name);
                };

                return (
                  <div className="ml-12 mb-20 taskStatus">
                    <div className="Polaris-Labelled__LabelWrapper">
                      <div className="Polaris-Label">
                        <label
                          id="employeePhoneLabel"
                          for="employeePhone"
                          className="Polaris-Label__Text"
                        >
                          {getTranslatedText(
                            intl,
                            'admin.emailNotification.prop.container.bcc.label'
                          )}
                        </label>
                      </div>
                    </div>
                    <CreatableSelect
                      value={bccUsers}
                      // styles={
                      //   errors?.statusId
                      //     ? {
                      //         ...MenuStyle,
                      //         ...statusStylesObject,
                      //         ...reactSelectErrorStyles
                      //       }
                      //     : {
                      //         ...MenuStyle,
                      //         ...statusStylesObject,
                      //         ...{
                      //           container: (provided, state) => ({
                      //             ...provided,
                      //             width: '150px'
                      //           })
                      //         }
                      //       }
                      // }
                      name="valueselector"
                      classNamePrefix="value_selector"
                      components={{ IndicatorSeparator, DropdownIndicator }}
                      formatGroupLabel={formatGroupLabel}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        menu: (base) => ({ ...base, zIndex: 9999 })
                      }}
                      isMulti
                      onChange={updatebccUsers}
                      options={allData}
                      // isSearchable={false}
                    />
                  </div>
                );
              }}
            </Query>
            {/* <SelectUsers
              updateField={updatebccUsers}
              query={GET_ALL_TECHS}
              label={<Label>{'BCC Users'}</Label>}
              params={{
                client: AccountClient
              }}
              methodName="getAllTechnicians"
              value={bccUsers}
              placeholder={getTranslatedText(
                intl,
                'admin.emailNotification.bcc'
              )}
              isMulti
            /> */}
            <br />
          </>
        )}
        {/* <SelectContainer className="fx select-wrapper">
          <div className="container">
            <Label>
              {getTranslatedText(
                intl,
                'admin.emailNotification.prop.container.sign.label'
              )}
            </Label>
            <Select
              options={emailSignatureTypeOptions}
              onChange={handleEmailSignatureTypeChange}
              value={emailSignatureType}
              placeholder={getTranslatedText(
                intl,
                'admin.emailNotification.prop.container.sign'
              )}
              name="valueselector"
              classNamePrefix="value_selector"
              components={{ IndicatorSeparator, DropdownIndicator }}
              formatGroupLabel={formatGroupLabel}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }}
            />
          </div>
        </SelectContainer> */}
      </div>
    </div>
  );
}

export default injectIntl(EmailSenderForm);
